module.exports = __webpack_public_path__ + "cca18276a1c6e97572a79cf1be1e63fd.png";